<style scoped>
.explain {
  background: #fff;
  border-radius: 4px;
  text-align: left;
  margin: 20px 14px;
  overflow: hidden;
  padding: 0 20px 30px 20px;
}
.explain-header {
  padding: 20px 0;
  overflow: hidden;
  /* border-bottom: 1px solid #ccc; */
}
.explain-header b {
  font-size: 20px;
  font-weight: 400;
  color: #323233;
}
.explain-contain {
  padding: 20px 20px 30px 60px;
}
.explain-title {
  /* width: 130px; */
  display: inline-block;
}
.cost-img {
  width: 300px;
}
.state-approval {
  font-size: 12px;
  display: inline-block;
  padding: 3px 10px 4px 10px;
  border-radius: 10px;
  margin-left: 20px;
}

.now-state {
  width: 112px;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  box-sizing: border-box;
}
.state-now-pass {
  color: #fff;
  background: #4fa1a4;
}
.state-now-unpass {
  color: red;
  border: 1px solid red;
}
.state-now-revoke {
  color: #4fa1a4;
  border: 1px solid #4fa1a4;
}
.state-back {
  width: 84px;
  height: 32px;
  line-height: 32px;
  font-size: 16px;
  color: #323233;
  text-align: center;
  cursor: pointer;
  border: 1px solid #c8c9cd;
}
.approval {
  margin: 10px 10px 60px 10px;
  background: #fff;
  border-radius: 4px;
  text-align: left;
  padding: 30px 60px 60px 60px;
}
.approval-list {
  display: flex;
}
.list-left {
  margin-right: 10px;
}
.left-box {
  width: 55px;
  height: 55px;
  color: #fff;
  line-height: 51px;
  background: #999;
  text-align: center;
  border-radius: 4px;
  margin: 0px 10px;
}
.left-line {
  width: 0.5px;
  height: 40px;
  background: #999;
  margin-left: 37px;
}
.approval-list:last-child .list-left .left-line {
  display: none;
}
/deep/.el-dialog__body {
  padding: 10px 20px;
}
.state-now {
  color: #e59940;
  background: rgba(255, 242, 224, 0.23);
  /* border: 1px solid #e59940; */
  /* border: 1px solid #C8C9CD; */
}
.state-pass {
  color: #4fa1a4;
  background: rgba(79, 161, 164, 0.1);
  /* border: 1px solid #4fa1a4; */
}
.state-reject {
  color: rgb(255, 85, 85);
  background: rgba(255, 85, 85, 0.07);
  /* border: 1px solid rgb(255, 85, 85); */
}
.state-undo {
  color: rgb(197, 202, 213);
  background: #fff;
  border: 1px solid rgb(197, 202, 213);
}
.title-pass {
  background: #4fa1a4 !important;
}
.title-reject {
  background: red !important;
}
.explain-item {
  line-height: 40px;
  display: flex;
}
.explain-title {
  flex-shrink: 0;
}
.explain-content {
  display: inline-block;
  /* line-height: 30px; */
}
.link-active {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}
.doc-img {
  width: 80px;
  height: 80px;
  margin-right: 24px;
  cursor: pointer;
}
.doc-img img {
  width: 80px;
  height: 80px;
}
</style>
<template>
  <div class="approval-detail" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="explain">
      <div class="explain-header">
        <b class="font-S20">{{ flowType | flowType }}</b>
        <span
          class="state-approval state-now"
          v-if="fillDetail.approvalState == 'N' || fillDetail.approvalState == 'A'"
          >审批中</span
        >
        <span class="state-approval state-pass" v-if="fillDetail.approvalState == 'Y'">已通过</span>
        <span class="state-approval state-reject" v-if="fillDetail.approvalState == 'R'">已驳回</span>
        <!-- <span class="state-approval state-undo" v-if="!fillDetail">已撤销</span> -->
        <span  :class="fillDetail.approvalState == 'Y' ? 'state-back fr' : 'state-back fr ml30'"  @click="$router.go(-1)"  >返回</span
        >
        <!-- <span class="state-back fr mr15 ml30" v-if="fillDetail.approveState == 'Y'" @click="toPrinting()">打印</span> -->
        <span  class="now-state state-now-unpass fr mr15"  v-if="approveStaffGuid == staffGuid && (fillDetail.approvalState == 'N' || fillDetail.approvalState == 'A')"
          @click="toReject()"  >驳回</span>
        <span  class="now-state state-now-pass fr mr15"  v-if="approveStaffGuid == staffGuid && (fillDetail.approvalState == 'N' || fillDetail.approvalState == 'A')"
          @click="toPass()"  >通过</span>
        <!-- <span
          class="now-state state-now-pass fr mr15"
          v-if="fillDetail.approveState == 'R' && fillDetail.staffGuid == staffGuid"
          @click="reSubmit()"
          >重新提交</span
        > -->
        <!-- <span  class="now-state state-now-revoke fr mr15"  v-if="fillDetail.approveState == 'N' && fillDetail.staffGuid == staffGuid"
          @click="toRevoke()">撤销</span> -->
      </div>
      <div class="cost-title-list">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">申请信息</span>
      </div>
      <div class="explain-contain">
        <div class="explain-item">
          <span class="explain-title">申请人：</span> <span class="explain-content">{{ fillDetail.createUserName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">提交时间：</span>
          <span class="explain-content">{{ fillDetail.createTime | getTime }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">所在部门：</span>
          <span class="explain-content">{{ organisationName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">所在公司：</span>
          <span class="explain-content">{{ tenantName }}</span>
        </div>
        <!-- <div class="explain-item">
          <span class="explain-title">员工姓名：</span>
          <span class="explain-content">{{ fillDetail.organisationName }}</span>
        </div> -->
        <div class="explain-item">
          <span class="explain-title">医疗机构：</span>
          <span class="explain-content">{{ fillDetail.medName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">所属区域：</span>
          <span class="explain-content">{{ fillDetail.venue }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">详细地址：</span>
          <span class="explain-content">{{ fillDetail.address }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">标准名称：</span>
          <span class="explain-content">{{ fillDetail.medStandardName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">机构级次/等级：</span>
          <span class="explain-content">{{ fillDetail.orgRank | orgRankType}}{{ fillDetail.orgGrade | orgGradeType}}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">机构类别：</span>
          <span class="explain-content">{{ fillDetail.orgType | orgType}}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">医院联系人：</span>
          <span class="explain-content">{{ fillDetail.contacts }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">手机号码：</span>
          <span class="explain-content">{{ fillDetail.contactTel }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">联系人性别：</span>
          <span class="explain-content">{{ fillDetail.contactSex }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">机构性质：</span>
          <span class="explain-content">{{ fillDetail.medType }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">营业收入：</span>
          <span class="explain-content">{{ fillDetail.income }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">行业地位：</span>
          <span class="explain-content">{{ fillDetail.tradeLevel }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">医疗保险定点机构：</span>
          <span class="explain-content">{{ fillDetail.isMedicalInsurance }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">新农合定点机构：</span>
          <span class="explain-content">{{ fillDetail.isNewCountryCooperation }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">采购负责人：</span>
          <span class="explain-content">{{ fillDetail.buyStaffName }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">需求科室：</span>
          <span class="explain-content">{{ fillDetail.needOffice }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">累计拜访次数：</span>
          <span class="explain-content">{{ fillDetail.visitCount }}</span>
        </div>
        <div class="explain-item">
          <span class="explain-title">竞品情况：</span>
          <span class="explain-content">{{ fillDetail.competingGoodsInfo }}</span>
        </div>
      </div>
      <div class="cost-title-list mb25">
        <span class="cost-title-list-line"></span>
        <span class="cost-title-list-txt">流程审批</span>
      </div>
      <flowList
        :approvalList="approvalList"
        :carbonName="carbonName"
        :approveState="fillDetail.approvalState"
      ></flowList>
    </div>
    <div class="h20"></div>
    <el-dialog title="驳回流程" :visible.sync="dialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="dialogVisiblePass" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggestPass"> </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import flowList from '@/components/flowList.vue';
export default {
  components: {
    flowList,
  },
  data() {
    return {
      dialogVisible: false,
      dialogVisiblePass: false,
      fillDetail: '',
      approveSuggest: '',
      approveSuggestPass:"",
      flowName: '潜在客户信息申请',
      carbonName: '',
      tenantName:'',
      approvalList: [],
      approveStaffGuid: '',
      staffGuid: '',
      imgList: [],
      url: '',
      flowType: '00004',
      fullscreenLoading: false,
      meetingPlanList:[],
      currentStaffGuid:'',
      organisationName:''
    };
  },
  created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.staffGuid = userinfo.staffGuid;
    this.approveStaffGuid = this.$route.query.approveStaffGuid || '';
    this.tenantName = this.$route.query.tenantName || '';
    this.organisationName = this.$route.query.organisationName || '';
    this.getData();
    this.getApprovalList();
    // this.getMeetingCaList();
  },
  methods: {
    caCodeToDesc(listStr) {
      if (listStr != '') {
         listStr = listStr.replace(/"/g,'').replace(/[\\]/g,'').replace(/\[/g,'').replace(/\]/g,'').replace(/\,/g,'；');
         return listStr;
      }
    },
    changeEnter(content) {
      if (content == '' || content == null) {
        return '无';
      } else {
        content = content.replace(/\n/g, '</br>');
        return content;
      }
    },
    getData() {
      let self = this;
      self.fullscreenLoading = true;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/med/data/get/` + self.$route.query.bizGuid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fullscreenLoading = false;
            res.data.data.needOffice = JSON.parse(res.data.data.needOffice);
            self.fillDetail = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取流程列表
    getApprovalList() {
      let self = this;
      self.api
        .postCan(
          `/${serverConfig.msSalesPerformService}/approve/data/get-flow-running-node?flowType=00004&guid=` +
            self.$route.query.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.approvalList = res.data.data;
            self.approvalList.sort((n1, n2) => {
              return n1.orderNum - n2.orderNum;
            });
            self.carbonName = JSON.parse(res.data.data[0].ccGuids)[0].name;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //打印
    toPrinting() {
      let self = this;
      self.$router.push({
        path: '/reportProcess',
        query: {
          guid: self.$route.query.guid,
          flowType: '00004',
          productGuid:this.$route.query.productGuid
        },
      });
    },
    toPass() {
      let self = this;
      self.dialogVisiblePass = true;
    },
    //通过
    toPassSubmit() {
      let self = this;
      self
        .$confirm('操作后不可恢复，确定审批通过吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let query = {
            guid: self.$route.query.guid,
            flowType: self.flowType,
            approveSuggest:self.approveSuggestPass,
            approveStaffGuid:self.staffGuid
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/allow-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('审批通过！');
              // self.getData();
              // self.getApprovalList();
              sessionStorage.refresh = 1;
              self.$router.push({
                path: '/processList',
                query:{
                  productGuid:this.$route.query.productGuid
                }
              });
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消审批！',
          });
        });
    },
    toReject() {
      let self = this;
      self.dialogVisible = true;
    },
    //驳回
    toRejectSubmit() {
      let self = this;
      if (self.approveSuggest == '') {
        self.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: self.$route.query.guid,
        flowType: self.flowType,
        approveSuggest: self.approveSuggest,
        approveStaffGuid:self.staffGuid
      };
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/backup-flow`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.fullscreenLoading = false;
          self.$message.success('驳回成功！');
          // self.getData();
          // self.getApprovalList();
          sessionStorage.refresh = 1;
          self.dialogVisible = false;
          self.$router.push({
            path: '/processList',
            query:{
              productGuid:this.$route.query.productGuid
            }
          });
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //撤销
    toRevoke() {
      let self = this;
      self
        .$confirm('确定撤销吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          let query = {
            guid: self.$route.query.guid,
            flowType: self.flowType,
            approveStaffGuid:self.staffGuid,
            productGuid:this.$route.query.productGuid
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/approve/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              // self.getData();
              // self.getApprovalList();
              sessionStorage.refresh = 1;
              self.$router.push({
                path: '/processList',
              });
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
  },
};
</script>
